import classes from "./confirmModal.module.css";

export const ConfirmModal = ({
  title,
  message,
  onConfirm,
  onCancel,
}) => {
  return (
    <div
      className={classes.modalOverlay}
      onClick={onCancel}
    >
      <div
        className={classes.modalBox}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={classes.modalHeader}>
          <h3 className={classes.modalTitle}>
            {title}
          </h3>
        </div>

        <p className={classes.modalMessage}>
          {message}
        </p>

        <div className={classes.modalActions}>
          <button
            className={classes.cancelBtn}
            onClick={onCancel}
          >
            Cancel
          </button>

          <button
            className={classes.confirmBtn}
            onClick={onConfirm}
          >
            Yes, Change Status
          </button>
        </div>
      </div>
    </div>
  );
};